module.exports = __webpack_public_path__ + "img/esuvidha_award.97553f1e.jpeg";